const AppColors = {
  primary: '#00B074',
  primaryActive: '#1BA05C',
  primaryLight: '#BDFF9F',

  danger: '#E14E54',
  dangerActive: '#D43B41',
  dangerLight: '#FFF5F8',

  warning: '#F6C000',
  warningActive: '#E9B500',
  warningLight: '#FFF8DD',

  info: '#2984EE',
  infoActive: '#1877E7',
  infoLight: '#ECF8FF',

  purple:'#9B51E0',
  
  gray: {
    0: 'rgba(24, 24, 62, 1)',
    100: '#F9F9F9',
    200: '#EEF1FA',
    300: '#DBDFF1',
    400: '#B6BBD0',
    500: '#9CA2B8',
    600: '#7E8299',
    700: '#72728B',
    800: '#494968',
    900: '#18183E',
  },

  green: 'rgba(52, 199, 89, 1)',
};

export default AppColors;
